<template>
    <div class="ath-visual-progress-bar"
        :style="{height: `${height}px`, ...uiColorVars}"
        role="progressbar"
        aria-valuemin="0"
        :aria-valuemax="max"
        :aria-valuenow="uiValue"
        :aria-label="uiLabel">
        <div v-if="uiPercent > 0"
            class="el-fill"
            :style="{width: `${uiPercent}%`, minWidth: `${height}px`}"></div>
    </div>
</template>

<script>
/**
 * A thin rounded bar showing how far a value is toward a maximum
 */
export default {
    name: 'mead-progress-bar',
    props: {
        /**
         * Current progress, from 0 to `max`. Values outside that range are clamped.
         */
        value: {type: Number, default: 0},
        /**
         * Value that counts as complete.
         */
        max: {type: Number, default: 100},
        /**
         * Height of the bar in pixels. The bar fills the width of its container.
         */
        height: {type: Number, default: 6},
        /**
         * Color of the fill: a COLOR_STYLES value (e.g. "primary"), a tint of one (e.g. "primary-20")
         * or any CSS color (e.g. "#BAC3C4"). Set to an empty string for a muted gray fill.
         */
        color: {type: String, default: () => MeadCommon.COLOR_STYLES.ACTIVE},
        /**
         * Color of the unfilled track: a COLOR_STYLES value, a tint of one (e.g. "active-20") or any
         * CSS color. Defaults to a light gray when empty.
         */
        trackColor: {type: String, default: ''},
        /**
         * What the bar measures, used for the screen reader description. Passed through I18N.go.
         */
        label: {type: String, default: ''},
    },
    computed: {
        uiColorVars: function () {
            return {
                ...MeadCommon.colorVars(this.color, {bg: '--progress-fill'}),
                ...MeadCommon.colorVars(this.trackColor, {bg: '--progress-track'}),
            };
        },
        uiValue: function () {
            return Math.min(Math.max(this.value, 0), this.max);
        },
        uiPercent: function () {
            return this.max > 0 ? (this.uiValue / this.max) * 100 : 0;
        },
        uiLabel: function () {
            return this.label ? MeadCommon.I18N.go(this.label) : null;
        },
    },
};
</script>
<style lang="scss">
.ath-visual-progress-bar {
    width: 100%;
    overflow: hidden;
    border-radius: 999px;
    background-color: var(--progress-track, var(--c-stencil-bg));

    .el-fill {
        height: 100%;
        border-radius: inherit;
        background-color: var(--progress-fill, var(--c-scrollbar-bg));
        transition: width .3s ease;
    }
}
</style>
